import React from "react";
import { BudgetSummary } from "../components/SpendAnalyzer";
import IncomeGoalCard from "../components/IncomeGoalCard";

/**
 * The dashboard. Entry lives in the bottom sheet, so this is read-only.
 *
 * The `p-4 space-y-4` wrapper is needed now that the entry form no longer
 * supplies the page chrome — BudgetSummary previously sat flush against the
 * top edge because AddExpense provided the padding below it.
 */
const Home = ({ budget, incomeGoal, expensesThisMonth, incomeThisMonth, outstanding }) => {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen p-4 space-y-4">
      <BudgetSummary budget={budget} expensesThisMonth={expensesThisMonth} />
      <IncomeGoalCard
        goal={incomeGoal}
        incomeThisMonth={incomeThisMonth}
        outstanding={outstanding}
      />
    </div>
  );
};

export default Home;
